import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import Icon from '../components/Icon';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { login, isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      window.location.href = '/dashboard';
    }
  }, [isAuthenticated]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await login(username, password);
    if (result.success) {
      window.location.href = '/dashboard';
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-600 to-red-800 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full shadow-2xl">
        <div className="text-center mb-8">
          <div className="w-20 h-20 gradient-red rounded-full flex items-center justify-center mx-auto mb-4 shadow-red">
            <Icon name="home" size={40} color="white" />
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-1">SIMPLON Burkina Faso</h2>
          <p className="text-gray-500 text-sm">Plateforme de Gestion des Insertions</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="username" className="flex items-center text-sm font-medium mb-2 text-gray-700">
              <Icon name="user" size={16} className="mr-2 text-gray-500" />
              Nom d'utilisateur
            </label>
            <input
              id="username"
              name="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoComplete="username"
              className="input-field"
              placeholder="Identifiant"
            />
          </div>
          <div>
            <label htmlFor="password" className="flex items-center text-sm font-medium mb-2 text-gray-700">
              <Icon name="lock" size={16} className="mr-2 text-gray-500" />
              Mot de passe
            </label>
            <div className="relative">
              <input
                id="password"
                name="password"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                className="input-field pr-10"
                placeholder="Mot de passe"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-red-600 transition-colors"
                aria-label={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
              >
                <Icon name={showPassword ? 'eyeOff' : 'eye'} size={20} />
              </button>
            </div>
          </div>
          <button
            type="submit"
            className="btn-primary w-full flex items-center justify-center space-x-2"
          >
            <Icon name="check" size={18} color="white" />
            <span>Se connecter</span>
          </button>
        </form>
        {/* <div className="mt-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
          <p className="font-semibold text-gray-700 mb-3 flex items-center text-sm">
            <Icon name="info" size={16} className="mr-2 text-red-600" />
            Comptes de test
          </p>
          <div className="space-y-2 text-xs">
            <div className="flex items-center justify-between">
              <span className="flex items-center text-gray-600">
                <Icon name="admin" size={14} className="mr-1.5 text-red-600" />
                Admin:
              </span>
              <div className="flex items-center space-x-1">
                <code className="bg-white px-2 py-1 rounded border text-gray-800">admin</code>
                <span className="text-gray-400">/</span>
                <code className="bg-white px-2 py-1 rounded border text-gray-800">Admin@2024</code>
              </div>
            </div>
            <div className="flex items-center justify-between">
              <span className="flex items-center text-gray-600">
                <Icon name="formateur" size={14} className="mr-1.5 text-red-600" />
                Formateur:
              </span>
              <div className="flex items-center space-x-1">
                <code className="bg-white px-2 py-1 rounded border text-gray-800">formateur</code>
                <span className="text-gray-400">/</span>
                <code className="bg-white px-2 py-1 rounded border text-gray-800">Form@2024</code>
              </div>
            </div>
            <div className="flex items-center justify-between">
              <span className="flex items-center text-gray-600">
                <Icon name="lecteur" size={14} className="mr-1.5 text-red-600" />
                Lecture:
              </span>
              <div className="flex items-center space-x-1">
                <code className="bg-white px-2 py-1 rounded border text-gray-800">lecteur</code>
                <span className="text-gray-400">/</span>
                <code className="bg-white px-2 py-1 rounded border text-gray-800">Lect@2024</code>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Login;

